export default {
  // API
  SET_NETWORKS(state, networks) {

    if (networks == null ){
          state.networks = [];
    }else{
          state.networks = networks;
    }

    state.networkOverviewGraphs = {};
    state.networkPlayerGraphs = {};
    if (state.activeNetwork == null && state.networks.length > 0){
      state.activeNetwork = state.networks[0]
    }
  },
  SET_ACTIVE_NETWORK(state, network) {
    state.activeNetwork = network
  },
  SET_NETWORK_FIREWALL_ENTRIES(state, entries) {
    state.networkFirewallEntries = entries
  },
  ADD_NETWORK_FIREWALL_ENTRY(state, entry) {
    state.networkFirewallEntries.unshift(entry)
  },
  REMOVE_NETWORK_FIREWALL_ENTRY(state, entry_id) {
    const ItemIndex = state.networkFirewallEntries.findIndex((p) => p.id === entry_id)
    state.networkFirewallEntries.splice(ItemIndex, 1)
  },
  ADD_NETWORK(state, network) {
    state.networks.unshift(network)
  },
  UPDATE_NETWORK(state, network) {
    const networkIndex = state.networks.findIndex(t => t.id === network.id)
    if (networkIndex == -1) {
      console.log("Unable to update network ID in mutator:", network.id);
      return;
    }
    Object.assign(state.networks[networkIndex], network)
  },

  SET_NETWORK_ASN_ENTRIES(state, entries) {
    state.networkASNEntries = entries
  },
  ADD_NETWORK_ASN_ENTRY(state, entry) {
    state.networkASNEntries.unshift(entry)
  },
  REMOVE_NETWORK_ASN_ENTRY(state, entry_id) {
    const ItemIndex = state.networkASNEntries.findIndex((p) => p.id === entry_id)
    state.networkASNEntries.splice(ItemIndex, 1)
  },

  SET_NETWORK_COUNTRY_ENTRIES(state, entries) {
    state.networkCountryEntries = entries
  },
  ADD_NETWORK_COUNTRY_ENTRY(state, entry) {
    state.networkCountryEntries.unshift(entry)
  },
  REMOVE_NETWORK_COUNTRY_ENTRY(state, entry_id) {
    const ItemIndex = state.networkCountryEntries.findIndex((p) => p.id === entry_id)
    state.networkCountryEntries.splice(ItemIndex, 1)
  },

  UPDATE_NETWORK_OVERVIEW_GRAPH(state, data) {
    let networkID = data[0];
    let seriesData = data[1];

    // shallow copy object so it triggers the vue watcher
    let newNetworkOverviewGraphs = state.networkOverviewGraphs;
    newNetworkOverviewGraphs[networkID] = {
      chartData: [seriesData],
    };

    if (!seriesData.data || seriesData.data.length == 0) {
      newNetworkOverviewGraphs[networkID].lastPlayerCount = 0;
    } else {
      newNetworkOverviewGraphs[networkID].lastPlayerCount = seriesData.data[seriesData.data.length - 1];
    }

    state.networkOverviewGraphs = newNetworkOverviewGraphs;
  },
  UPDATE_NETWORK_PLAYERS_GRAPH(state, data) {
    let networkID = data[0];
    let seriesData = data[1];

    // shallow copy object so it triggers the vue watcher
    let newNetworkGraphs = state.networkPlayerGraphs;
    newNetworkGraphs[networkID] = {
      chartData: [seriesData],
    };

    if (!seriesData.data || seriesData.data.length == 0) {
      newNetworkGraphs[networkID].lastPlayerCount = 0;
    } else {
      newNetworkGraphs[networkID].lastPlayerCount = seriesData.data[seriesData.data.length - 1];
    }

    state.networkPlayerGraphs = newNetworkGraphs;
  },

  SET_SUB_USERS(state, users) {
    state.networkSubUsers = users
  },

  ADD_SUB_USER(state, user) {
    state.networkSubUsers.unshift(user)
  },
  UPDATE_SUB_USER(state, {user_id,perms}) {
    const userIndex = state.networkSubUsers.findIndex(t => t.id === user_id)
    Object.assign(state.networkSubUsers[userIndex].perms, perms)
  },
  REMOVE_SUB_USER(state, user_id) {
    const ItemIndex = state.networkSubUsers.findIndex((p) => p.id === user_id)
    state.networkSubUsers.splice(ItemIndex, 1)
  },
  UPDATE_NETWORK_PREMIUM(state, { network_id, premium }) {
    const network = state.networks.find(({ id }) => network_id === id)
    if (!network) {
      return
    }
    if (state.activeNetwork && state.activeNetwork.id === network_id) {
      state.activeNetwork.premium = premium
    }

    network.premium = premium
  },
}
